import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=9bd79cee&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=9bd79cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd79cee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bd79cee')) {
      api.createRecord('9bd79cee', component.options)
    } else {
      api.reload('9bd79cee', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=9bd79cee&scoped=true&", function () {
      api.rerender('9bd79cee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g405pW6P39kO/JS/comp/DocBox.vue"
export default component.exports